<template>
    <div class="m-2 mb-6">
        <div class="bg-light font-medium p-2">{{ title }}
            <!--v-show="parentContactsNotInGroup.length>0"-->
            <button v-if="allowLink"
                    type="button"
                    class="btn icon-button pull-right"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="true"
                    style="padding: 0 !important;">
                <a href="#">
                    <i class="mdi mdi-account-search" style="margin-right:7px; font-size: 13px"></i>
                </a>
            </button>

            <div class="dropdown-menu dropdown-menu-right shadow text-center"
                 x-placement="bottom-start">
                <span class="small p-1 font-medium">{{ selectContactText }}</span>

                <div class="dropdown-divider"></div>

                <div v-if="availableContacts.length !== 0">
                    <a v-for="contact in availableContacts" :key="contact.id" class="dropdown-item small" href="" style="padding-left: 40px; padding-right: 40px;"
                       @click.prevent="addParentContactToGroup(contact)">
                        {{ contact.full_name }} <span v-if="contact.external_source !== null"
                                                      class="mdi mdi-link-variant text-muted position-absolute"
                                                      style="margin-left: 2px; font-size: .5rem">
                        {{ contact.external_source }}
                    </span>
                    </a>
                </div>

                <a v-else class="dropdown-item small" href="#" @click.prevent="">
                    {{ noValuesText }}
                </a>
            </div>
        </div>

        <div v-if="!isLoadingContacts && mutableContacts && mutableContacts.length !== 0">
            <table style="width:100%">
                <tr v-for="contact in mutableContacts" :key="contact.id">
                    <td class="p-2">
                        <slot :contact="contact">
                            <div class="content-group">
                                <h5 class="mb-0">{{contact.full_name !== "Unnamed Record" ? contact.full_name :
                                    contact.contact_name}}
                                    <span class="badge badge-pill badge-muted"
                                          v-if="contact.pivot.status === 'archived'">archived</span>
                                    <i v-if="contact.pivot.primary" class="mdi mdi-check-decagram"
                                       data-toggle="tooltip"
                                       data-original-title="Primary Contact"></i>
                                </h5>
                                <span class="mail-desc"
                                      style="font-size:0.8em !important">{{ contactDetailString(contact) }}</span>
                            </div>
                        </slot>
                    </td>

                    <td style="width: 50px" class="text-right">
                        <!--Contact Action Buttons DropDown-->
                        <div class="btn-group" style="margin-right: 10px">
                            <button type="button"
                                    class="btn icon-button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="true"
                                    style="padding: 0 4px; font-size: 16px !important;">
                                <i class="mdi mdi-dots-vertical"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right shadow"
                                 x-placement="bottom-start"
                                 style="">
                                <a class="dropdown-item" href="" @click.prevent="editContact(contact)">
                                    View Contact Details
                                </a>
                                <a v-show="contact.pivot.status!=='archived'"
                                   class="dropdown-item" href="" @click.prevent="makePrimary(contact)">
                                    Make Primary
                                </a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="#" @click.prevent="sendEmail(contact)">Send Email</a>
                                <a class="dropdown-item" href="#" @click.prevent="sendSMS(contact)">Send SMS</a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="" @click.prevent="removeContact(contact)">
                                    Remove Contact
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <div v-else-if="isLoadingContacts" class="flex items-center justify-center mt-2"> Loading {{ role }}s</div>

        <div v-else>
            <p class="dropdown-item small text-center">
                No {{ role }}s
            </p>
        </div>

        <contact-view-edit
            ref="editContact"
            :contact="currentContact"
            :hide-juristic-section="hideJuristicSection"
            :hide-juristic-seciton="false"
            :contactable="contactable"
            :contactable-id="contactableId"
            @contact-created="fetchContacts">
        </contact-view-edit>
    </div>
</template>

<script>

export default {
    name: "contacts-list-single-role",

    props: {
        title: {
            type: String,
            required: true
        },
        contacts: {
            type: Array,
            required: false
        },
        suggestedContacts: {
            type: Array,
            required: false,
        },
        showArchivedContacts: {
            type: Boolean,
            default: false
        },
        api: {
            type: String,
            required: true
        },
        role: {
            type: String,
            required: true
        },
        contactable: {
            type: String,
            required: true
        },
        contactableId: {
            type: Number,
            required: true
        },
        allowCreate: {
            type: Boolean,
            default: false
        },
        allowLink: {
            type: Boolean,
            default: true
        },
        selectContactText: {
            type: String,
            default: "Select Contact"
        },
        noValuesText: {
            type: String,
            default: "No Contact"
        },
        // this variable is used to specify whether the edit
        // form of the contact should show the 'Juristic Section' options at all.
        // Typically you want to disable this for service provider contact groups
        // Where the juristic details are directly on that entity
        hideJuristicSection: {
            type: Boolean,
            default: false
        },
    },

    data () {
        return {
            mutableContacts: [],
            currentContact: {},
            isLoadingContacts: true,
        };
    },

    created: function () {
        let self = this;

        Bus.$on("new-contacts-available", function (role = null) {
            if (!role || role === self.role) {
                self.fetchContacts();
            }
        });

        Bus.$on("contact-deleted", function (role) {
            if (role === self.role) {
                self.fetchContacts();
            }
        });

        Bus.$on("contact-updated", function (role) {
            if (role === self.role) {
                self.fetchContacts();
            }
        });
    },

    mounted () {
        this.fetchContacts();
    },

    computed: {
        availableContacts () {
            if (!this.suggestedContacts) {
                return [];
            }
            return this.suggestedContacts.filter(this.filterContactsToSelect);
        },
    },

    methods: {
        filterContactsToSelect (contact) {
            return (this.mutableContacts.findIndex(c => c.id === contact.id) === -1) && contact.pivot.status !== "archived";
        },

        editContact (contact) {
            this.currentContact = contact;
            this.$refs.editContact.setRole(this.role);
            this.$refs.editContact.toggleContactForm();
        },

        contactDetailString (contact) {
            return contact.mobile ? contact.email + " | " + contact.mobile : contact.email;
        },

        moveContactToGroupList (contact) {
            this.mutableContacts.unshift(contact);
        },

        fetchContacts () {
            this.isLoadingContacts = true;
            axios.get(this.api, ({
                params: {
                    role: this.role,
                }
            })).then(response => {
                this.mutableContacts = response.data;
                this.isLoadingContacts = false;
            }).catch(errors => {
                this.isLoadingContacts = false;
                window.toastr.error("Error retrieving " + this.role + " contacts.");
            });
        },

        addParentContactToGroup (contact) {
            App.post("/contacts/" + contact.id + "/attach", new AppForm({
                role: this.role,
                contactable: this.contactable,
                contactable_id: this.contactableId,
            })).then(() => {
                toastr.success("Contact linked to " + this.contactable.substring(4));
                this.moveContactToGroupList(contact);
            }).catch(() => {
                window.toastr.error("Could not link contact!");
            });
        },

        makePrimary (contact) {
            App.post("/contacts/" + contact.id + "/primary", new AppForm({
                role: this.role,
                contactable: this.contactable,
                contactable_id: this.contactableId,
            })).then(() => {
                toastr.success("New primary " + this.role + " contact set");
                this.fetchContacts();
            }).catch(() => {
                window.toastr.error("Could not set contacts as primary " + this.role);
            });
        },

        removeContact (contact) {
            let index = this.mutableContacts.indexOf(contact);
            App.patch("/contacts/" + contact.id + "/remove", new AppForm({
                role: this.role,
                contactable: this.contactable,
                contactable_id: this.contactableId
            })).then(() => {
                toastr.success("Contact removed from list");
                this.mutableContacts.splice(index, 1);
            }).catch(() => {
                window.toastr.error("Could not remove " + this.role + " contact!");
            });
        },

        sendEmail (contact) {
            this.$emit("create-email", contact);
        },

        sendSMS (contact) {
            Bus.$emit("show-sms-create-form", contact);
        },
    },
};
</script>
